import Icon from '../components/Icon.vue'

Icon.register({"band-aid":{"width":640,"height":512,"paths":[{"d":"M0 160V352C0 387.3 28.7 416 64 416H160V96H64C28.7 96 0 124.7 0 160zM576 96H480V416H576C611.3 416 640 387.3 640 352V160C640 124.7 611.3 96 576 96zM192 416H448V96H192V416zM368 184C381.3 184 392 194.7 392 208S381.3 232 368 232 344 221.3 344 208 354.7 184 368 184zM368 280C381.3 280 392 290.7 392 304S381.3 328 368 328 344 317.3 344 304 354.7 280 368 280zM272 184C285.3 184 296 194.7 296 208S285.3 232 272 232 248 221.3 248 208 258.7 184 272 184zM272 280C285.3 280 296 290.7 296 304S285.3 328 272 328 248 317.3 248 304 258.7 280 272 280z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/band-aid.js
// module id = 19Bp
// module chunks = 0